<script lang="ts">
    import {onMount} from "svelte";


    onMount(() => {
    });


</script>

<div class="rights-notation-page standard-page">


    <h1>権利表記</h1>
    <pre>
        PAC-MAN™& ©Bandai Namco Entertainment Inc.


    </pre>


</div>
<style lang="scss">
    .rights-notation-page {

    }
</style>